import { createContext, useContext, useState, useEffect } from 'react';
import translations from "../utils/translations";

const LayoutLanguageContext = createContext();

export const LayoutLanguageProvider = ({ children }) => {


  const [layoutLanguage, setLayoutLanguage] = useState(() => {
    const storedLanguage = localStorage.getItem('layoutLanguage');

    if (storedLanguage) {
      return storedLanguage;
    } else {
      const browserLanguage = navigator.language.split('-')[0]; // Get browser language, e.g., 'en' from 'en-US'
      return browserLanguage === 'fr' ? 'Français' : 'English'; // Set default language based on browser language
    }
  });

  useEffect(() => {
    // Store the current language in localStorage whenever it changes
    localStorage.setItem('layoutLanguage', layoutLanguage);
  }, [layoutLanguage]);

  const changeLayoutLanguage = (language) => {
    setLayoutLanguage(language);
  };

  const layoutT = (key) => {
    return translations[key][layoutLanguage] || key;
  };

  return (
    <LayoutLanguageContext.Provider value={{ layoutLanguage, changeLayoutLanguage, layoutT }}>
      {children}
    </LayoutLanguageContext.Provider>
  );
};

export const useLayoutLanguage = () => useContext(LayoutLanguageContext);